import { IItemCSSDimensions } from 'types/card';

const CARD_WIDTH = 1080;
const CARD_HEIGHT = 1920;

const MAX_SIZE = 0.5;

export const getScaledRelativeDimensions = (
  width: number,
  height: number,
): IItemCSSDimensions => {
  if (!height) {
    return {
      width: undefined,
      height: undefined,
      aspectRatio: undefined,
    };
  }

  const scale = Math.min(CARD_WIDTH / width, CARD_HEIGHT / height, 1);

  let scaledWidth = width * scale;
  let scaledHeight = height * scale;

  if (
    scaledWidth / CARD_WIDTH > MAX_SIZE ||
    scaledHeight / CARD_HEIGHT > MAX_SIZE
  ) {
    scaledWidth *= MAX_SIZE;
    scaledHeight *= MAX_SIZE;
  }

  return {
    width: `${(scaledWidth / CARD_WIDTH) * 100}%`,
    height: `${(scaledHeight / CARD_HEIGHT) * 100}%`,
    aspectRatio: width / height,
  };
};
